import * as types from "../constants/actionTypes";

const initialState = {
  sending: false,
  sendSuccess: null,
  sendError: null,
  segments: [],
  segmentsLoading: false,
  segmentsError: null,
  history: [],
  historyLoading: false,
  historyError: null,
  historyTotalCount: 0,
  quota: null,
  quotaLoading: false,
  quotaError: null,
  estimatedRecipients: null,
  estimatedRecipientsLoading: false,
  estimatedRecipientsError: null,
  cancelling: false,
  cancelSuccess: null,
  cancelError: null,
};

export default function notifications(state = initialState, action) {
  switch (action.type) {
    case types.SEND_NOTIFICATION_REQUEST:
      return { ...state, sending: true, sendSuccess: null, sendError: null };
    case types.SEND_NOTIFICATION_SUCCESS:
      return { ...state, sending: false, sendSuccess: action.result.body };
    case types.SEND_NOTIFICATION_FAILURE:
      return {
        ...state,
        sending: false,
        sendError: action.description || "Failed to send notification",
      };

    case types.GET_SEGMENTS_REQUEST:
      return { ...state, segmentsLoading: true, segmentsError: null };
    case types.GET_SEGMENTS_SUCCESS:
      return {
        ...state,
        segmentsLoading: false,
        segments: action.response.segments || [],
      };
    case types.GET_SEGMENTS_FAILURE:
      return { ...state, segmentsLoading: false, segmentsError: action.error };

    case types.GET_NOTIFICATION_HISTORY_REQUEST:
      return { ...state, historyLoading: true, historyError: null };
    case types.GET_NOTIFICATION_HISTORY_SUCCESS:
      return {
        ...state,
        historyLoading: false,
        history:
          action.result?.body?.notifications ||
          action.result?.notifications ||
          [],
        historyTotalCount:
          action.result?.body?.total_count || action.result?.total_count || 0,
      };
    case types.GET_NOTIFICATION_HISTORY_FAILURE:
      return { ...state, historyLoading: false, historyError: action.error };

    case types.CLEAR_NOTIFICATION_STATE:
      return { ...initialState, segments: state.segments, quota: state.quota };

    case types.GET_BROADCAST_QUOTA_REQUEST:
      return { ...state, quotaLoading: true, quotaError: null };
    case types.GET_BROADCAST_QUOTA_SUCCESS:
      return {
        ...state,
        quotaLoading: false,
        quota: action.result?.body || action.result,
      };
    case types.GET_BROADCAST_QUOTA_FAILURE:
      return { ...state, quotaLoading: false, quotaError: action.error };

    case types.ESTIMATE_RECIPIENTS_REQUEST:
      return {
        ...state,
        estimatedRecipientsLoading: true,
        estimatedRecipientsError: null,
      };
    case types.ESTIMATE_RECIPIENTS_SUCCESS:
      return {
        ...state,
        estimatedRecipientsLoading: false,
        estimatedRecipients: action.result?.body || action.result,
      };
    case types.ESTIMATE_RECIPIENTS_FAILURE:
      return {
        ...state,
        estimatedRecipientsLoading: false,
        estimatedRecipientsError: action.error,
      };

    case types.CLEAR_ESTIMATED_RECIPIENTS:
      return {
        ...state,
        estimatedRecipients: null,
        estimatedRecipientsLoading: false,
        estimatedRecipientsError: null,
      };

    case types.CANCEL_NOTIFICATION_REQUEST:
      return {
        ...state,
        cancelling: true,
        cancelSuccess: null,
        cancelError: null,
      };
    case types.CANCEL_NOTIFICATION_SUCCESS:
      return {
        ...state,
        cancelling: false,
        cancelSuccess: action.result?.body || action.result,
      };
    case types.CANCEL_NOTIFICATION_FAILURE:
      return {
        ...state,
        cancelling: false,
        cancelError: action.description || "Failed to cancel notification",
      };

    default:
      return state;
  }
}
